<template>
    <div>
        <app-login-header class="mt-2" :page="page_name"></app-login-header>
        <div class="container-fluid mainContainerLoginRegistration">
            <div class="loader-info" v-if="pageLoader">
                <loaderShoonya></loaderShoonya>
            </div>
            <div class="row resMobLoginShoonya" style="align-items: center; justify-content: center; flex-direction: row; height: 100vh;">
                <leftSideBarRegister v-if="inserted_id == -1"></leftSideBarRegister>
                <leftSideBarLogin v-if="inserted_id != -1"></leftSideBarLogin>
                <div class="register_main_right">
                    <flash-message v-if="errMsz == ''"></flash-message>
                    <div class="lr-right-input-section d-flex">
                        <img v-if="inserted_id == -1" src="../../../../static/prism/images/shoonya_icon-png.png" width="80" alt="#" class="fadeIn" />
                        <h1  v-if="inserted_id == -1">Step Into Honest Trading <br> With Shoonya</h1>
                        <h1 v-if="inserted_id != -1">Verify your details</h1>
                        <div class="lr-right-input-section-internal">
                            <div class="content" v-if="STEP == 1">
                                <form class="p_registration_forms" action="#">
                                <!-- <form action="#"> -->
                                    <div class="form-group field-wrapper"
                                        :class="{ error: validation.hasError('message') }">
                                        <input placeholder=" " type="email" name="email" class="float-field" v-model="email"
                                            @keyup="customValidation(email, 'e')" style="text-transform:lowercase" @input="convertToLower">
                                        <label for="emailaddress" class="float-label">Enter your email</label>
                                        <div class="message" style="color:red" v-if="dataKey == 'e'">
                                            {{ message }}
                                        </div>
                                    </div>
                                    <div class="form-group field-wrapper">
                                        <input placeholder=" " type="text" name="mobile" class="float-field" maxlength="10"
                                            v-model="mobile" @keyup="customValidation(mobile, 'm')">
                                        <label for="mobile" class="float-label">Mobile</label>
                                        <div class="message" style="color:red" v-if="dataKey == 'm'">
                                            {{ message }}
                                        </div>
                                    </div>
                                    <div class="form-group field-wrapper" v-if="inserted_id != -1">
                                        <input placeholder=" " type="text" name="maidenname" class="float-field"
                                            v-model="mobile_OTP" @keyup="customValidation(mobile_OTP, 'mo')" />
                                        <label for="maidenname" class="float-label">Enter Mobile OTP</label>
                                        <div class="message" style="color:red" v-if="dataKey == 'mo'">
                                            {{ message }}
                                        </div>
                                    </div>

                                    <div class="form-group field-wrapper" v-if="inserted_id != -1">
                                        <input placeholder=" " type="text" name="maidenname" class="float-field"
                                            v-model="email_OTP" @keyup="customValidation(email_OTP, 'eo')" />
                                        <label for="maidenname" class="float-label">Enter Email OTP</label>
                                        <div class="message" style="color:red" v-if="dataKey == 'eo'">
                                            {{ message }}
                                        </div>
                                    </div>

                                    <div class="clearfix"></div>

                                    <div class="form-group mb-3 field-wrapper" v-if="inserted_id != -1">
                                        Didn't receive otp? <a href="#" v-on:click="resendOTP()" class="ml-1">
                                            <rotate-ccw-icon size="1x" class="custom-class"> </rotate-ccw-icon> Resend
                                            OTP</a>
                                    </div>
                                    <div class="signupbtn full-width otpverifiedcls" id="otpverifiediv"
                                        v-if="inserted_id != -1">
                                        <button href="#" id="valleafotpid PJ_step_2" v-on:click.prevent=verify_OTP()
                                            class="prism_btn">VERIFY OTP</button>
                                    </div>
                                    <div class="signupbtn full-width" v-else>
                                        <button v-on:click.prevent=getStarted() class="prism_btn" id="PJ_step_1">
                                            Continue</button>
                                    </div>
                                </form>
                                <p v-if="inserted_id == -1" class="mt-2" style="color:#c3c3c3;line-height: 13px;">
                                    *By signing up, you agree to receive a call from a Shoonya representative to help you with the account opening process.<br> 
                                    <b style="font-weight: bold;color:#939393">Note</b>- Online account opening is currently unavailable for NRI, HUF, minor, joint, and non-individual accounts.
                                </p>
                            </div>
                            <div class="content" v-if="STEP == 2">
                                <div class="p_registration_forms" action="#">
                                    <div class="form-group field-wrapper"
                                        style="text-transform:uppercase; margin-top: 20px;"
                                        :class="{ error: validation.hasError('pan_number') }" v-show="panshowfield"
                                        @focusout="checkPanFocusOut()">
                                        <i v-if="!pan_number || validation.firstError('pan_number')" style="position: absolute; right: 15px; top: 15px; font-size: 20px; color: #ffcb8e; cursor: pointer;" 
                                        class="fa fa-info-circle" @click="openPANModal()"></i>
                                        <input placeholder=" " type="text" name="pan_number" v-model="pan_number"
                                            class="float-field" style="text-transform:uppercase"
                                            onselectstart="return false" @input="restrictSpace" onpaste="return false;" onCopy="return false"
                                            onCut="return false" onDrag="return false" onDrop="return false"
                                            ref="panNumber" />
                                        <label for="pannumber" class="float-label">PAN Card No</label>
                                        <!-- <div class="message" style="color:red;text-transform: initial;" v-if="pan_number == 'confirm_pan'">
                                            {{ message }}
                                        </div> -->
                                        <div class="message" style="color:red;text-transform: initial;line-height: 16px;">
                                            {{ validation.firstError('pan_number') }}
                                        </div>
                                    </div>
                                    
                                    <div class="form-group field-wrapper" style="text-transform:uppercase"
                                        v-show="!panshowfield">
                                        <div class="float-field d-flex align-items-center justify-content-between">
                                            XXXXXXX{{ pan_number.substr(pan_number.length - 3) }}
                                            <a class="editPanCard d-flex align-items-center" href="#"
                                                @click="panshowfieldShow()">Edit
                                                <edit-icon size="1.5x" class="custom-class ml-2"></edit-icon>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="checkbox-wrapper customnewcheckbox text-left field-wrapper mt-4"  :class="{error: validation.hasError('confirmConsent')}">
                                        <label class="fancy_radiochk_btn" for="check15">
                                            <input id="check15" class="filled-in" type="checkbox" v-model="confirmConsent"/>
                                            
                                            <i class="checkmark"></i>
                                            <small>By selecting this you allow us to fetch the linked information for a seamless onboarding process.</small>
                                        </label> 
                                        <div class="message">
                                            {{ validation.firstError('confirmConsent') }}
                                        </div>
                                    </div> 
                                    <!-- <label class="pull-left fancy_radiochk_btn">*By clicking submit you consent to fetch the linked information for a seamless onboarding process.
                                        <input type="checkbox"><span class="checkmark"></span>
                                    </label> -->
                                    </div>
                                    <!-- <div class="form-group field-wrapper" style="text-transform:uppercase"
                                        :class="{ error: validation.hasError('confirm_pan') }">
                                        <input placeholder=" " type="text" name="confirm_pan" v-model="confirm_pan"
                                            class="float-field" style="text-transform:uppercase" onpaste="return false;"
                                            @input="confirm_pan = $event.target.value.replace(/\s/g, '').toUpperCase()" />
                                        <label for="pannumber" class="float-label">Confirm Pan Card No</label>

                                        <div class="message" style="color:red;text-transform: initial;" v-if="dataKey == 'confirm_pan'">
                                            {{ message }}
                                        </div>
                                        <div class="message" style="color:red;text-transform: initial;" v-else>
                                            {{ validation.firstError('confirm_pan') }}
                                        </div>
                                    </div> -->
                                    <!-- <div class=" form-group field-wrapper ">

                                        <label class="enterdatelabel">Enter Date of birth as per PANCARD</label>
                                        <div class="calenderRowDMY" id="calendar">

                                            <div class="flex-1">
                                                <select class="FormDate__input--day float-field" v-model="select_user_date"
                                                    :class="{ error: validation.hasError('select_user_date') }">
                                                    <option value="">Select Date</option>
                                                    <option :value="key" v-for="(key, value) in user_date">{{ value }}
                                                    </option>
                                                </select>
                                                <div class="message" style="color:red">
                                                    {{ validation.firstError('select_user_date') }}
                                                </div>
                                            </div>
                                            <div class="flex-1">
                                                <select class="FormDate__input--day float-field" v-model="select_user_month"
                                                    :class="{ error: validation.hasError('select_user_month') }">
                                                    <option value="">Select Month</option>
                                                    <option :value="value" v-for="(key, value)  in user_month">{{ key }}
                                                    </option>
                                                </select>
                                                <div class="message" style="color:red">
                                                    {{ validation.firstError('select_user_month') }}
                                                </div>
                                            </div>
                                            <div class="custom_date flex-1">
                                                <date-picker :format="DatePickerFormat" :placeholder="'Select Year'"
                                                    :disabledDates="disabledDates" minimum-view="year" name="datepicker"
                                                    id="input-id" v-model="select_user_year"
                                                    input-class="FormDate__input FormDate__input--day"
                                                    :class="{ error: validation.hasError('select_user_year') }">
                                                </date-picker>
                                                <div class="message" style="color:red">
                                                    {{ validation.firstError('select_user_year') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="message" style="color:red" v-if="dataKey == 'd'">
                                            {{ message }}
                                        </div>

                                    </div> -->
                                    <!-- <div class="signupbtn">
                                        <button href="#" v-on:click.prevent=verify_dob() class="prism_btn"
                                            id="valleafleadid PJ_step_3">Submit</button>
                                    </div> -->
                                    <div class="signupbtn">
                                        <button href="#" class="prism_btn" v-on:click.prevent=VerifyDigitapPAN()
                                            id="valleafleadid PJ_step_3">Submit</button>
                                    </div>
                                </div>
                            </div>
                            <div class="sign-modal cstmModal verifyPAN" v-if="DummyPANSHOW">
                                <div class="modal_content">
                                    <!-- <div
                                        class="head-sec d-flex align-items-start justify-content-between p-3 border-bottom">
                                        <div class="pr-4">
                                            <h2 class="modal-title">PAN Card</h2>
                                        </div>
                                    </div> -->
                                    <div class="PANPPopUp">
                                        <h2 @click="DummyPANSHOW = false" class="modal-title">X</h2>
                                    </div>
                                    <div class="body_sec text-center p-3">
                                        <div class="d-flex">
                                            <img class="img-fluid m-0" src="../../../../static/prism/images/PANInfoModal.png">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <form class="p_registration_forms" action="#">
                                    <div class="form-group field-wrapper"
                                        :class="{ error: validation.hasError('message') }">
                                        <input placeholder=" " type="email" name="email" class="float-field" v-model="email"
                                            @keyup="customValidation(email, 'e')">
                                        <label for="emailaddress" class="float-label">Enter your email</label>
                                        <div class="message" style="color:red" v-if="dataKey == 'e'">
                                            {{ message }}
                                        </div>
                                    </div>
                                    <div class="form-group field-wrapper">
                                        <input placeholder=" " type="text" name="mobile" class="float-field" maxlength="10"
                                            v-model="mobile" @keyup="customValidation(mobile, 'm')">
                                        <label for="mobile" class="float-label">Mobile</label>
                                        <div class="message" style="color:red" v-if="dataKey == 'm'">
                                            {{ message }}
                                        </div>
                                    </div>
                                    <div class="form-group field-wrapper">
                                        <button class="btn btn-outline-secondary" type="button">Continue</button>
                                    </div>
                                    
                                </form>
                                <p>*By signing up you agree to receive a call from a Shoonya representative to help you with the
                                    account opening process. Also, Account opening is currently not available for NRI, HUF, Minor,
                                    Joint & Non-Individual accounts.
                                </p> -->
                        </div>

                    </div>
                </div>
                <div v-if="Object.keys(panAttempt).length > 0" class="sign-modal cstmModal verifyPAN panDesignBlueBg">
                    <div class="modal_content">
                        <div class="body_sec p-3">
                            <flash-message></flash-message>
                            <div class="panHeadImg text-center">
                                <img src="../../../../static/prism/images/pan_head_img.svg">
                            </div>
                            
                            <div class="pr-4">
                                <h2 class="modal-title">Verify your PAN</h2>
                            </div>
                            <h3 class="mb-3">Its me, <span class="text-uppercase"></span>
                            {{  panAttempt.panInfoRes.fullName }}
                            </h3>
                            <div class="pr-4">
                                <h2 class="modal-title">PAN Number</h2>
                            </div>
                            <h3 class="mb-2"><span class="text-uppercase"></span>
                            {{  panAttempt.panInfoRes.panNumber }}
                            </h3>
                            <div class="d-flex" style="justify-content: space-between;">
                                <div>
                                    <p class="mb-0">Ensure your PAN details are correct</p>
                                    <button class="prism_btn mb-1" @click="panConfirm()">Confirm</button>
                                    <span class="panWrongName d-block">
                                        Wrong name ?
                                        <button class="btn re-enter-btn shadow-none p-0"
                                        @click="panReEnter()">Re-enter PAN
                                        </button>
                                    </span>
                                </div>
                                <div>
                                    <img width="114" src="../../../../static/prism/images/panDummy.png">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script>
<script>
    //====================================================
    import Vue from 'vue';
    import SimpleVueValidation from 'simple-vue-validator';
    import leftSideBarRegister from './register_left_section.vue';
    import leftSideBarLogin from './login_left_section.vue';
    const Validator = SimpleVueValidation.Validator;
    Vue.use(SimpleVueValidation);
    //====================================================
    import DatePicker from 'vuejs-datepicker'
    import LoginHeader from '../shared/login/login_header'
    import FormDate from './datePicker'
    import Footer from '../shared/footer'
    import * as types from '@/types'
    import { mapActions } from 'vuex' 
    import moment from 'moment'
    import { EditIcon } from 'vue-feather-icons' 
    const SHA256 = require("crypto-js/sha256");
    import { prismMixins } from '@/plugins/prism'
    import loaderShoonya from '../shared/loaderShoonya.vue';
    import { checkDomainValidity } from '../../../utils/excludedDomains';

    window.getDocumentData = resp => {
      dispatchEvent(new CustomEvent('digilocker', {detail:resp}))
    }

    // import DatePicker from 'vue2-datepicker';
    // import 'vue2-datepicker/src/locale/languages.js';

    export default {
        name: 'REGISTER', 
         mixins: [prismMixins],       
        data () {
            return {
                select_user_date : '',
                select_user_month : '',
                select_user_year : '',
                user_date:{
                    '1':'01', '2':'02', '3':'03', '4':'04', '5':'05', '6':'06', '7':'07', '8':'08', '9':'09', '10':'10', '11':'11', '12':'12', '13':'13', '14':'14', '15':'15', '16':'16', '17':'17' , '18':'18' , '19':'19', '20':'20' , '21':'21', '22':'22' , '23':'23', '24':'24', '25':'25' ,'26':'26' , '27':'27' , '28':'28', '29':'29', '30':'30', '31':'31'
                },
                user_month: {'1' : 'January',  '2' : 'Febuary', '3' : 'March','4' : 'April', '5' : 'May', '6' : 'June', '7' : 'July', '8' : 'August', '9' : 'September', '10' : 'October', '11' : 'November', '12' : 'December'},
                user_year: {'1900':'1900', '1900':'1900', '1900':'1900'},
                DatePickerFormat: 'yyyy', 
                DummyPANSHOW: false,
                confirmConsent:false,
                errMsz : '',
                panAttempt : {},
                page_name : "register",
                rout : this.$router,
                email: "",
                mobile: "",
                pan_number:"",
                mobile_OTP: "",
                email_OTP : "",
                dob : "",
                utm_landing_page : '',
                publisher_id : 0,
                adv_id : 0,
                getData : '',
                transaction_id : 0,
                confirmDob : "",
                inserted_id: -1,
                STEP: 1,
                pan_var_verify : false,
                pageLoader : false,
                message : "",
                dataKey : "",
                confirm_pan : '',
                disabledDates :{
                    customPredictor: function(date) {
                      if(date.getFullYear() < 1900){
                        return true
                      }
                    }
                },
                pickerOptions: {
                  disabledDate(time) { 
                    return time.getTime() > new moment();
                  }
                },
                panshowfield : true,
                monthJson : {'JAN' : 1, 'FEB' : 2 ,  'MAR' : 3, 'APR' : 4 ,  'MAY' : 5, 'JUNE' : 6 , 'JULY' : 7 , 'AUG' : 8 , 'SEP' : 9 , 'OCT' : 10 , 'NOV' : 11 , 'DEC' : 12 , },
                webengageCallback : true,
                getStartedCallback: false,
                resendOTPCallback : false,
                resendOTPStatus : false,
                webengageCheck : false,
            }
        },
        validators: {
            confirmConsent: function(value) {
                return Validator.custom(function() {
                    if (!Validator.isEmpty(value)) {
                    if (value == false) {
                        return "Consent is required.";
                    } else {
                        return;
                    }
                    } else {
                    return "required";
                    }
                });
                },
            pan_number: function (value) {
                return Validator.custom(function () {
                    if (!Validator.isEmpty(value)) {
                        var val = value.trim()
                        var regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
                        if(!(regpan.test(val))){
                            return `Please enter your PAN for identity verification. Make sure it's the correct 10-character alphanumeric format (e.g., ABCDE1234F)`
                        }
                    }else{return `Please enter your PAN for identity verification. Make sure it's the correct 10-character alphanumeric format (e.g., ABCDE1234F)`}
                });
            },
            // select_user_date: function (value) {
            //     return Validator.custom(function () {
            //         if (Validator.isEmpty(value)) {
            //            return 'Date required'
            //         }
            //     });
            // },
            // select_user_month: function (value) {
            //     return Validator.custom(function () {
            //         if (Validator.isEmpty(value)) {
            //            return 'Month required'
            //         }
            //     });
            // },
            // select_user_year: function (value) {
            //     return Validator.custom(function () {
            //         if (Validator.isEmpty(value)) {
            //            return 'Year required'
            //         }
            //     });
            // },
            // 'confirm_pan, pan_number': function (confirm_pan, pan_number) {
            //     if (this.submitted || this.validation.isTouched('confirm_pan')) {
            //         return Validator.value(confirm_pan).required().match(pan_number);
            //     }
            // }
        },
        components: {
            appLoginHeader : LoginHeader,
            appFooter : Footer,
            //datepicker : Datepicker,
            leftSideBarRegister,
            leftSideBarLogin,
            EditIcon,
            DatePicker,
            FormDate : FormDate,
            loaderShoonya
        },
        methods:{
            openPANModal(){
                if(this.DummyPANSHOW==true){
                    this.DummyPANSHOW=false;
                }
                else{
                    this.DummyPANSHOW=true;
                }
            },
            filterAlphabets() {
            },
            disabledDate(date){
                return date.getTime() > new Date();
            },
            panshowfieldShow(){
                this.panshowfield = true;
                const _that = this
                setTimeout(function(){ _that.$refs.panNumber.focus(); }, 300);
                
            },
            convertToLower(event){
                if(this.email)
                    this.email = this.email.toLowerCase();
            },
            restrictSpace(event) {
                this.pan_number = event.target.value.replace(/\s/g, ''); // Removes spaces
                this.pan_number = this.pan_number.replace(/[^\x00-\x7F]/g, "");
            },
            checkPanFocusOut(){
                if(!this.validation.firstError('pan_number') && this.pan_number != ''){
                    this.panshowfield = false
                    this.pan_number = this.pan_number.toUpperCase()
                }
            },
            customFormatter(date) {
                return moment(date).format('DD-MM-YYYY');
            },
            ...mapActions({
                _runCreateLead: types.RUN_CREATE_LEAD,
                _runVerifyLeadRegister: types.RUN_VERIFY_LEAD_OTP,
                _runVerifyDob: types.RUN_VERIFY_DOB,
                _runPanVerify: types.RUN_PAN_VERIFY,
                _runWebEngageUser: types.RUN_WEB_ENGAGE_USER,
            }),
            customValidation(getData,key){
                this.dataKey = key
                //console.log('getData===>', getData)
                if(getData == '' && key == 'e'){
                    this.message = 'Please enter a valid email address to complete the registration process.'
                }
                if(getData == '' && key == 'm'){
                    this.message = 'Please enter a valid mobile number to complete the registration process.'
                }else if(getData != '' && key == 'm'){  
                    const phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                    if(!(getData.trim().match(phoneno))){
                        this.message = 'Please enter a valid mobile number to complete the registration process.'
                    }else{this.message = ''}
                }else if(getData != '' && key == 'e'){  
                    const email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if(!(getData.trim().match(email))){
                        this.message = 'Please enter a valid email address to complete the registration process.'
                    }else if(checkDomainValidity(getData)){
                        this.message = 'The email domain is invalid.'
                    }
                    else this.message = ''
                }else if(getData != '' && (key == 'mo' || key == 'eo' || key == 'd' || key == 'cd')){  
                    this.message = ''
                }
            },
            resendOTP() {
                console.log("resend OTP Triggered")
                webengage.track("Resend OTP Triggered", {"Value": "Yes"});

                this.create_leads(false, true);

            },
            getStarted() {

                this.create_leads(true, false);
               
            },
            create_leads(callWebEngage = false , resendOTPStatus = false){
              
                // if(this.email != "" && this.mobile != "" && this.pan_number != "" && this.confirm_pan != ""){
                if(this.email != "" && this.mobile != "" ){
                    this.message = ''
                    this.dataKey = ''
                    const phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                    const email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    
                    if(!(this.email.trim().match(email))){
                        this.dataKey = 'e'
                        this.message = 'Please enter a valid email address to complete the registration process.'
                        //this.flashError('invalid email', {timeout: 10000});
                    }else if(checkDomainValidity(this.email)){
                        this.dataKey = 'e'
                        this.message = 'Please enter a valid email domain to complete the registration process'
                    }
                    else if(!(this.mobile.trim().match(phoneno))){
                        this.dataKey = 'm'
                        this.message = 'Please enter a valid mobile number to complete the registration process.'
                        //this.flashError('please enter valid mobile number', {timeout: 10000});
                    }else{
                        if(callWebEngage) {
                            this.webengageCallback = true
                        } else {
                            this.webengageCallback = false
                        }
                        
                        if(resendOTPStatus) {
                            this.resendOTPCallback = true
                        } else {
                            this.resendOTPCallback = false
                        }

                        let input_json = {
                            "email": this.email.trim().toLowerCase(),
                            "mobile": this.mobile.trim(),
                            "pan_number": this.pan_number.trim(),
                            "parameter" : this,
                            "router" :this.$router
                        }
                        if(localStorage.getItem('utm_landing_page') && localStorage.getItem('publisher_id')){
                            input_json.utm_landing_page = localStorage.getItem('utm_landing_page')
                            input_json.publisher_id = localStorage.getItem('publisher_id')
                            input_json.adv_id =  Date.parse(new Date()) + Math.floor(100000 + Math.random() * 900000)
                            input_json.transaction_id = Date.parse(new Date()) + Math.floor(100000 + Math.random() * 900000)
                        }
                        
                        this._runCreateLead(input_json)

                    } 
                }if(this.email == ""){
                    this.dataKey = 'e' ; this.message = "Please enter a valid email address to complete the registration process."
                }else if(this.mobile == ""){
                    this.dataKey = 'm' ; this.message = "Please enter a valid mobile number to complete the registration process."
                }
                // if(this.pan_number == ""){
                //     this.dataKey = 'pan_number' ; this.message = "required"
                // }if(this.confirm_pan == ""){
                //     this.dataKey = 'confirm_pan' ; this.message = "required"
                // }
             
           },
            webEngageUser(check_kra) {
      
                const _that = this
                let user = this.$store.getters['GET_USER']

                if(check_kra) {
                    _that.webengageCheck = true
                }
         
                _that._runWebEngageUser({
                    "email": user.email,
                    "mobile": user.mobile_no,
                    "parameter": _that,
                })

            },
            startSession() {
                console.log("Get Started")
                webengage.track("Get Started", {"Value": "Yes"});
            },
            VerifyDigitapPAN(){
                let _that = this
                this.$validate().then(function (success){
                    console.log(success)
             
                    if(success){
                        webengage.track("Verify Pan Card Triggered", {"Value": "Yes"});
                        console.log("Verify Pan Card Triggered")
                        _that.webengageCheck = true;
                        _that.panDigitapFunc()
                        // _that.panNameFunc()
                    }
                    if(_that.pan_number == ""){
                        _that.dataKey = 'pan_number' ; _that.message = "required"
                    }
                    _that.webengageCheck = false;
                });
            },
            verify_dob(){
                let _that = this
                console.log('1',_that.dob)
                console.log('2',_that.select_user_date)
                console.log('3',_that.select_user_month)
                console.log('4',_that.select_user_year)
                this.$validate().then(function (success){
                    if(success){
                        let month =  _that.select_user_month
                        if(_that.select_user_month.length == 1){
                            month = '0'+_that.select_user_month
                        }
                        _that.dob =  _that.select_user_date+'-'+month+'-'+_that.select_user_year.getFullYear()
                        //  var dob1 = new Date(_that.dob);
                        // let year1 =  dob1.getFullYear()
                        // let month1 =  dob1.getMonth()
                        // let date1 =  dob1.getDate()
                        // //console.log(dob1 ,'==============',year1, month1, date1)

                        if( _that.dob != ""  &&  _that.dob != 'Invalid Date'){
                            var dob = new Date(_that.dob);
                            let get_year = new Date().getFullYear() - 18
                            if(moment(_that.dob).isAfter(new Date)){
                                _that.flashError("Date of birth can not be in future", {timeout: 10000});
                            }
                            else if(dob.getFullYear() > get_year){
                                _that.flashError("Oops! It Looks like you are a minor, refer to FAQs for guidance on age-related trading rules.", {timeout: 10000});
                            }
                            else{
                                _that.panDigitapFunc()
                                _that.panNameFunc()
                            }
                        }

                        // if(_that.dob == ""){
                        //     _that.dataKey = 'd' ; _that.message = "required"
                        // }else if(_that.confirmDob == ""){
                        //     _that.dataKey = 'cd' ; _that.message = "required"
                        // }else if(_that.confirmDob != _that.dob){
                        //     _that.dataKey = 'cd' ; _that.message = "Date of birth did not match"
                        // }
                    }
                    if(_that.pan_number == ""){
                        _that.dataKey = 'pan_number' ; _that.message = "required"
                    }else if(_that.confirm_pan == ""){
                        _that.dataKey = 'confirm_pan' ; _that.message = "The PAN confirmation doesn't match the initial entry. Please verify and ensure both entries are identical."
                    }
                    else if(_that.confirm_pan == _that.pan_number){
                        _that.dataKey = 'confirm_pan' ; _that.message = ""
                    }

                });
            },
            panReEnter() {
                webengage.track("Re-Enter Pan Card", {"Value": "Yes"});
                console.log('Re-Enter Pan Card')
                this.panNameFuncReAttempt()

            },
            panNameFuncReAttempt(){
                this.panAttempt = {}
                this.pan_number = ''
                this.dob = ''
                this.confirm_pan = ''
                this.panshowfield = true
                this.message = ''
                this.dataKey = ''
            },
            // panNameFunc(){
            //     const _that = this
            //     this.errMsz = ''
            //     let input_json = {
            //         "pan_no":_that.pan_number.trim().toUpperCase(),
            //         "phn_no": _that.mobile.trim(),
            //         "email": _that.email.trim().toLowerCase(),
            //         "lead_id": _that.inserted_id,
            //         "parameter" : _that
            //     }
            //     _that._runUserPanAttepmtNameApi(input_json)
            // },
            panNameFunc(){
                // webengage.track("Verify Pan Card Triggered", {"Value": "Yes"});
                // console.log("Verify Pan Card Triggered")
                const _that = this
                this.errMsz = ''
                let input_json = {
                    "pan_no":   'BLZPR4716D',
                    "phn_no":   '9999999999',
                    "email":    'ksharmafinvasia3@gmail.com',
                    "lead_id":  '807201',
                    "parameter" : _that
                }
                _that._runUserPanAttepmtNameApi(input_json)
            },
            panDigitapFunc(){
                const _that = this
                this.errMsz = ''
                let input_json = {
                    "pan_no":_that.pan_number.trim().toUpperCase(),
                    "phn_no": _that.mobile.trim(),
                    "email": _that.email.trim().toLowerCase(),
                    "lead_id": _that.inserted_id,
                    "consent": _that.confirmConsent,
                    "parameter" : _that
                }
                _that._runUserPanAttepmtDigitapApi(input_json)
            },
            panConfirm() {
                console.log("Confirm Pan Card Triggered")
                webengage.track("Confirm Pan Card Triggered", {"Value": "Yes"});
                this.signUp()
            },
            signUp(){
                const _that = this
                _that.dob = _that.panAttempt.panInfoRes.dob;
                console.log('_that.dob===>',_that.dob)
                // _that.dob =  _that.dob //moment(_that.dob).format('DD-MM-YYYY')
                let input_json = {
                    "email": _that.email.trim().toLowerCase(),
                    "mobile": _that.mobile.trim(),
                    "pancard":_that.pan_number.trim().toUpperCase(),
                    "dob": _that.dob,
                    "mobile_OTP": _that.mobile_OTP,
                    "email_OTP": _that.email_OTP,
                    "rout" : _that.rout,
                    "parameter" : _that,
                    "utm_landing_page" : _that.utm_landing_page,
                    "publisher_id" : _that.publisher_id,
                    "adv_id" : _that.adv_id,
                    "transaction_id" : _that.transaction_id,
                    "pan_username" : _that.panAttempt.panInfoRes.fullName
                }
                if(_that.$cookies.get('franchiseLead')){
                    input_json.ref_id = atob(_that.$cookies.get('franchiseLead'))
                }
                _that._runVerifyDob(input_json)
            },
            panVerify(){
                const _that = this
                this.$validate()
                .then(function (success){
                    if(success){
                        let input_json={
                            "rout" : _that.rout,
                            "parameter" : _that,
                            "pancard" : _that.pan_number.trim().toUpperCase()
                        }
                        _that._runPanVerify(input_json)
                    }
                });
            },
            verify_OTP(){
                if(this.inserted_id !== -1 && this.mobile_OTP != "" && this.email_OTP != ""){
                    const r = this.$router
                    // console.log("OTP Verified Triggered")
                    // webengage.track("OTP Verified Triggered", {"Value": "Yes"});
                    this._runVerifyLeadRegister({
                        "mobile_OTP": this.mobile_OTP,
                        "email_OTP": this.email_OTP,
                        "ID": this.inserted_id,
                        "parameter" : this,
                        "router" :r
                    })

                }if(this.mobile_OTP == ""){
                    this.dataKey = 'mo' ; this.message = "Please enter valid OTP"
                }if(this.email_OTP == ""){
                    this.dataKey = 'eo' ; this.message = "Please enter valid OTP"
                }
            },
            javascriptFunc(getData){
                if(parseInt(this.publisher_id) != 0 && parseInt(this.transaction_id) != 0 && parseInt(this.adv_id) != 0){
                    let getUrl = '' , jsonData = {} ;
                    if(getData == 'verify_otp'){
                        this.getData = getData
                        // getUrl = 'https://tracking.salesleaf.com/aff_goal?a=lsr&goal_name=otp-verified&adv_id=1&transaction_id='+this.transaction_id+'&adv_sub='+this.adv_id;
                        // jsonData = {    
                        //     "a" : "lsr",
                        //     "goal_name": "otp-verified",
                        //     "adv_id": this.publisher_id,
                        //     "transaction_id": this.transaction_id,
                        //     "adv_sub": this.adv_id
                        // }
                    }else{
                        this.getData = getData
                        // getUrl = 'https://tracking.salesleaf.com/aff_goal?a=lsr&goal_name=lead&adv_id=1&transaction_id='+this.transaction_id+'&adv_sub='+this.adv_id
                        // jsonData = {    
                        //     "a" : "lsr",
                        //     "goal_name": "lead",
                        //     "adv_id": this.publisher_id,
                        //     "transaction_id": this.transaction_id,
                        //     "adv_sub": this.adv_id
                        // }
                    }
                }




                    // let xhr = new XMLHttpRequest();
                    // xhr.open("GET", getUrl);

                    // xhr.onreadystatechange = function () {
                    //     if (xhr.readyState === 4) {
                    //         console.log('response===>',xhr.response);
                    //         console.log('responseText===>',xhr.responseText);
                    //         console.log('responseURL===>',xhr.responseURL);
                    //         console.log('responseType===>',xhr.responseType);
                    //         console.log('xhr===>',xhr);
                    //     }
                    // };
                    // xhr.send();
                    // $(document).ready(function() {
                    //     $.ajax({
                    //         url: getUrl,
                    //         type: "GET",
                    //         //dataType: 'json',
                    //         //data: jsonData,
                    //         success: function(result) {
                    //             console.log('111111111111')
                    //             console.log(jsonData,'innnnnnnnnnnnnnnnnnn',getUrl)
                    //             // console.log('result=============',result);
                    //         },
                    //         error: function(error) {
                    //             console.log('222222222222')
                    //              console.log(error);
                    //         }
                    //     });
                    // });
                //}
                
            },
            clearCookieFunc(){
                localStorage.removeItem('utm_landing_page')
                localStorage.removeItem('publisher_id')
            },
            callOTPTracking(){
                const el = document.getElementById('Lead');
                if(el){
                    el.remove();    
                }
                const iframe = document.createElement("iframe");
                iframe.src ="https://tracking.salesleaf.com/aff_goal?a=l&goal_name=otp-verified&adv_id=1&offer_id=2932&adv_sub=SUB_ID"
                iframe.setAttribute("scrolling", "no");
                iframe.setAttribute("frameborder", "0");
                iframe.setAttribute("width", "1");
                iframe.setAttribute("height", "1");
                iframe.setAttribute("id", "OTP");
                document.head.appendChild(iframe);
                //console.log('===>',document.head)
            },
            callPanTracking(){
                // $('head').prevAll('iframe').remove();
                const el = document.getElementById('OTP');
                if(el){
                    el.remove();    
                }
                const iframe = document.createElement("iframe");
                iframe.src ="https://tracking.salesleaf.com/aff_goal?a=l&goal_name=lead&adv_id=1&offer_id=2932&adv_sub=SUB_ID"
                iframe.setAttribute("scrolling", "no");
                iframe.setAttribute("frameborder", "0");
                iframe.setAttribute("width", "1");
                iframe.setAttribute("height", "1");
                iframe.setAttribute("id", "Lead");
                document.head.appendChild(iframe);
                //console.log('pan===>',document.head)
            }
        },
        created(){
            //delete this.$route.query.referral_links;
            if(this.$route.query.franchiseLead){
                this.$cookies.set("franchiseLead",this.$route.query.franchiseLead,"4m", null, ".finvasia.com");
                delete this.$route.query.franchiseLead
            }

            // if(localStorage.getItem('utm_landing_page') && localStorage.getItem('publisher_id')){
            //     this.clearCookieFunc()
            // }

            //'https://dev.finvasia.com:8086/register/?utm_landing_page=Valueleaf&publisher_id=123'  ATYPA6791R
            //https://prism.shoonya.com/register?utm_source=valueleaf&utm_term=123
            if(this.$route.query.utm_source && this.$route.query.utm_term && (this.$route.query.utm_source == 'valueleaf' || this.$route.query.utm_source == 'youtuberinfl')){
                localStorage.setItem('utm_landing_page', this.$route.query.utm_source)
                localStorage.setItem('publisher_id', this.$route.query.utm_term)
                this.$router.replace({ query: null });
            }
        }
    }
</script>

<style>
.PANPPopUp{position: relative;}
.PANPPopUp h2{    background: red;
    font-size: 14px;
    font-weight: bold;
    margin-top: 2px;
    cursor: pointer;
    position: absolute;
    color: #fff;
    width: 26px;
    height: 26px;
    text-align: center;
    line-height: 24px;
    right: -14px;
    border-radius: 33px;
    top: -16px;}
.panHeadImg{margin-bottom: 20px;}
.panDesignBlueBg .modal_content{
    width: 587px;
    /* height: 370px; */
    background: linear-gradient(249deg, #ACCEEC -38.48%, #F4F4F4 78.18%, #B195AE 141.6%, rgba(208, 201, 208, 0.23) 141.6%);
    border: 1px solid #F3F0F0;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.27);
}
.panDesignBlueBg .modal-title{
    color: #4D4842;
    font-family: Sora;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    text-transform: capitalize;
}
.panDesignBlueBg h3{
    color:#4D4842;
    font-family: Sora;
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    margin-bottom: 35px;
}
.panDesignBlueBg .prism_btn{   
    width: 222px;
    height: 54px;
    margin-top: 10px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.32);
    background: linear-gradient(89deg, #F09428 -7.32%, #F1B458 92.2%);
    color: #FFF;
    font-family: Sora;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 133.333% */
}
.panWrongName{
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    text-decoration-line: underline;
}
.panWrongName button{
    color: #F1A33F;
    margin-top: -2px;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    text-decoration-line: underline;
}
.display-none {
    display: none !important;
}

.register_main_right {
  background: var(--white);
  padding: 60px 8rem;
  margin-left: -24px;
  position: relative;
  /* z-index: 1; */
  /* min-width: 874px; */
  /* max-width: 874px; */
  border-radius: 8px;
}

.lr-right-input-section {
    height: 100%;
    flex-direction: column;
    justify-content: center;
}

.lr-right-input-section h1 {
    color: #242424;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
    /* 146.154% */
    text-transform: capitalize;
    margin-bottom: 12px;
}

.lr-right-input-section p {
    color: #484848;
    font-size: 10px;
    font-style: normal;
    font-weight: 300;
    line-height: 17px;
    /* 170% */
    text-transform: capitalize;
}

.lr-right-input-section img {
    margin-bottom: 24px;
}

.lr-right-input-section-internal {
    width: 441px;
}

.lr-right-input-section-internal button {
    background: linear-gradient(89.26deg, #F09428 -7.32%, #F1B458 92.2%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0) 86.21%);
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0em;
    color: #fff;
    width: 256px;
    height: 55px;
    text-align: center;
    border: none;
}
.vdp-datepicker input{height: 50px;    border-radius: 8px;font-size: 12px;}
select.float-field{font-size: 12px;}
/* .signupbtn a{
    background: linear-gradient(89.26deg, #F09428 -7.32%, #F1B458 92.2%),
        linear-gradient(180deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0) 86.21%);
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0em;
    color: #fff;
    width: 256px;
    height: 55px;
    text-align: center;
    border: none;
} */


/* .lr-right-input-section-internal input{height: 58px;color: #181818; font-size: 12px; font-style: normal; font-weight: 300; line-height: 37px
; text-transform: capitalize;margin-bottom: 26px;border-color: #C2C2C2;} */
@media screen and (max-width:1434px){ 
    .lr-left-info-section-top, .lr-left-info-section-bottom{padding:40px 5% !important}
    .sub-stats-left-info-section{padding-top: 0px !important;}
    .substats span{margin-top: 0px !important;}
}
</style>


// WEBPACK FOOTER //
// src/components/prism/Users/register.vue